import { useEffect, useState } from 'react';
import Icon from '../Icon/Icon';
import './CookiesBanner.scss';

const STORAGE_KEY = 'cookies-banner-accepted';

export default function CookiesBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasAccepted = localStorage.getItem(STORAGE_KEY);
    if (!hasAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookies-banner">
      <div className="flex">
        <Icon name="cookies" className="cookies-icon" />
        <p>Utilizamos cookies para te oferecer a melhor experiência.</p>
      </div>

      <Icon name="close" className="close-icon" onClick={handleClose} />
    </div>
  );
}
